// Generated by scripts/build-school-poems.mjs from the unified textbook
// primary and middle-school verse lists. Classical prose and post-Qing works are excluded.
import type { DynastyId, SchoolLevel } from '../types'

export interface SchoolPoemSeed {
  sourceId: string
  title: string
  author: string
  dynasty: DynastyId
  lines: string[]
  curriculumLevels: SchoolLevel[]
}

export const schoolPoemSeeds: SchoolPoemSeed[] = [
  {
    "sourceId": "5f6efd08156d",
    "title": "十五从军征",
    "author": "《乐府诗集》",
    "dynasty": "han",
    "lines": [
      "十五从军征，八十始得归。",
      "道逢乡里人：“家中有阿谁？”",
      "“遥看是君家，松柏冢累累。”",
      "兔从狗窦入，雉从梁上飞。",
      "中庭生旅谷，井上生旅葵。",
      "舂谷持作饭，采葵持作羹。",
      "羹饭一时熟，不知饴阿谁。",
      "出门东向看，泪落沾我衣。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "630c04c81858",
    "title": "观沧海",
    "author": "曹操",
    "dynasty": "han",
    "lines": [
      "东临碣石，以观沧海。",
      "水何澹澹，山岛竦峙。",
      "树木丛生，百草丰茂。",
      "秋风萧瑟，洪波涌起。",
      "日月之行，若出其中；",
      "星汉灿烂，若出其里。",
      "幸甚至哉，歌以咏志。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "d78b6331098e",
    "title": "龟虽寿",
    "author": "曹操",
    "dynasty": "han",
    "lines": [
      "神龟虽寿，犹有竟时。",
      "腾蛇乘雾，终为土灰。",
      "老骥伏枥，志在千里。",
      "烈士暮年，壮心不已。",
      "盈缩之期，不但在天。",
      "养怡之福，可得永年。",
      "幸甚至哉，歌以咏志。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "ef9cd9ba44bb",
    "title": "江南",
    "author": "汉乐府",
    "dynasty": "han",
    "lines": [
      "江南可采莲，莲叶何田田。鱼戏莲叶间。",
      "鱼戏莲叶东，鱼戏莲叶西，鱼戏莲叶南，鱼戏莲叶北。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "183d69f50755",
    "title": "长歌行",
    "author": "汉乐府",
    "dynasty": "han",
    "lines": [
      "青青园中葵，朝露待日晞。",
      "阳春布德泽，万物生光辉。",
      "常恐秋节至，焜黄华叶衰。",
      "百川东到海，何时复西归？",
      "少壮不努力，老大徒伤悲！"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "2d0c9ade951e",
    "title": "赠从弟·其二",
    "author": "刘桢",
    "dynasty": "han",
    "lines": [
      "亭亭山上松，瑟瑟谷中风。",
      "风声一何盛，松枝一何劲！",
      "冰霜正惨凄，终岁常端正。",
      "岂不罹凝寒？松柏有本性。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "7f09a756c9c0",
    "title": "迢迢牵牛星",
    "author": "佚名",
    "dynasty": "han",
    "lines": [
      "迢迢牵牛星，皎皎河汉女。",
      "纤纤擢素手，札札弄机杼。",
      "终日不成章，泣涕零如雨。",
      "河汉清且浅，相去复几许。",
      "盈盈一水间，脉脉不得语。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "d4f03889eaad",
    "title": "庭中有奇树",
    "author": "佚名",
    "dynasty": "han",
    "lines": [
      "庭中有奇树，绿叶发华滋。",
      "攀条折其荣，将以遗所思。",
      "馨香盈怀袖，路远莫致之。",
      "此物何足贵？但感别经时。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "0f6ad3fb3d95",
    "title": "画鸡",
    "author": "唐寅",
    "dynasty": "ming",
    "lines": [
      "头上红冠不用裁，满身雪白走将来。",
      "平生不敢轻言语，一叫千门万户开。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "dff01ff4925b",
    "title": "朝天子·咏喇叭",
    "author": "王磐",
    "dynasty": "ming",
    "lines": [
      "喇叭，唢呐，曲儿小腔儿大。官船来往乱如麻，全仗你抬声价。",
      "军听了军愁，民听了民怕。那里去辨甚么真共假？(甚么同：什么)",
      "眼见的吹翻了这家，吹伤了那家，只吹的水尽鹅飞罢！"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "d01bc3fbb10b",
    "title": "别云间",
    "author": "夏完淳",
    "dynasty": "ming",
    "lines": [
      "三年羁旅客，今日又南冠。",
      "无限山河泪，谁言天地宽。",
      "已知泉路近，欲别故乡难。",
      "毅魄归来日，灵旗空际看。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "c6c93895df0a",
    "title": "石灰吟",
    "author": "于谦",
    "dynasty": "ming",
    "lines": [
      "千锤万凿出深山，烈火焚烧若等闲。",
      "粉骨碎身浑不怕，要留清白在人间。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "0e1fe871ec57",
    "title": "式微",
    "author": "诗经·国风·邶风",
    "dynasty": "pre-qin",
    "lines": [
      "式微式微，胡不归？微君之故，胡为乎中露？",
      "式微式微，胡不归？微君之躬，胡为乎泥中？"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "15cd220102d6",
    "title": "蒹葭",
    "author": "诗经·国风·秦风",
    "dynasty": "pre-qin",
    "lines": [
      "蒹葭苍苍，白露为霜。所谓伊人，在水一方。溯洄从之，道阻且长。溯游从之，宛在水中央。",
      "蒹葭萋萋，白露未晞。所谓伊人，在水之湄。溯洄从之，道阻且跻。溯游从之，宛在水中坻。",
      "蒹葭采采，白露未已。所谓伊人，在水之涘。溯洄从之，道阻且右。溯游从之，宛在水中沚。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "cfe0289eb931",
    "title": "子衿",
    "author": "诗经·国风·郑风",
    "dynasty": "pre-qin",
    "lines": [
      "青青子衿，悠悠我心。纵我不往，子宁不嗣音？",
      "青青子佩，悠悠我思。纵我不往，子宁不来？",
      "挑兮达兮，在城阙兮。一日不见，如三月兮！"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "4c5705b99143",
    "title": "关雎",
    "author": "诗经·国风·周南",
    "dynasty": "pre-qin",
    "lines": [
      "关关雎鸠，在河之洲。窈窕淑女，君子好逑。",
      "参差荇菜，左右流之。窈窕淑女，寤寐求之。",
      "求之不得，寤寐思服。悠哉悠哉，辗转反侧。",
      "参差荇菜，左右采之。窈窕淑女，琴瑟友之。",
      "参差荇菜，左右芼之。窈窕淑女，钟鼓乐之。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "fa087546c81b",
    "title": "采薇(节选)",
    "author": "佚名",
    "dynasty": "pre-qin",
    "lines": [
      "昔我往矣，杨柳依依。",
      "今我来思，雨雪霏霏。",
      "行道迟迟，载渴载饥。",
      "我心伤悲，莫知我哀！"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "d88e3533fc4a",
    "title": "舟夜书所见",
    "author": "查慎行",
    "dynasty": "qing",
    "lines": [
      "月黑见渔灯，孤光一点萤。",
      "微微风簇浪，散作满河星。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "425fb837c387",
    "title": "村居",
    "author": "高鼎",
    "dynasty": "qing",
    "lines": [
      "草长莺飞二月天，拂堤杨柳醉春烟。",
      "儿童散学归来早，忙趁东风放纸鸢。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "838d9b401572",
    "title": "己亥杂诗",
    "author": "龚自珍",
    "dynasty": "qing",
    "lines": [
      "九州生气恃风雷，万马齐喑究可哀。",
      "我劝天公重抖擞，不拘一格降人材。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "d78d2dc95f06",
    "title": "己亥杂诗·其五",
    "author": "龚自珍",
    "dynasty": "qing",
    "lines": [
      "浩荡离愁白日斜，吟鞭东指即天涯。",
      "落红不是无情物，化作春泥更护花。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "7e5b6ca97ef2",
    "title": "浣溪沙·身向云山那畔行",
    "author": "纳兰性德",
    "dynasty": "qing",
    "lines": [
      "身向云山那畔行，北风吹断马嘶声，深秋远塞若为情！",
      "一抹晚烟荒戍垒，半竿斜日旧关城。古今幽恨几时平！"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "0a4d69889c65",
    "title": "长相思·山一程",
    "author": "纳兰性德",
    "dynasty": "qing",
    "lines": [
      "山一程，水一程，身向榆关那畔行，夜深千帐灯。",
      "风一更，雪一更，聒碎乡心梦不成，故园无此声。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "2093a1259999",
    "title": "潼关",
    "author": "谭嗣同",
    "dynasty": "qing",
    "lines": [
      "终古高云簇此城，秋风吹散马蹄声。",
      "河流大野犹嫌束，山入潼关不解平。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "58699ebb5e93",
    "title": "所见",
    "author": "袁枚",
    "dynasty": "qing",
    "lines": [
      "牧童骑黄牛，歌声振林樾。",
      "意欲捕鸣蝉，忽然闭口立。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "e5c9337524b7",
    "title": "竹石",
    "author": "郑板桥",
    "dynasty": "qing",
    "lines": [
      "咬定青山不放松，立根原在破岩中。",
      "千磨万击还坚劲，任尔东西南北风。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "fbbd80710c5e",
    "title": "三衢道中",
    "author": "曾几",
    "dynasty": "song",
    "lines": [
      "梅子黄时日日晴，小溪泛尽却山行。",
      "绿阴不减来时路，添得黄鹂四五声。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "ac19428da949",
    "title": "临江仙·夜登小阁忆洛中旧游",
    "author": "陈与义",
    "dynasty": "song",
    "lines": [
      "忆昔午桥桥上饮，坐中多是豪英。长沟流月去无声。杏花疏影里，吹笛到天明。",
      "二十余年如一梦，此身虽在堪惊。闲登小阁看新晴。古今多少事，渔唱起三更。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "6e4b9596b2f3",
    "title": "四时田园杂兴·其二十五",
    "author": "范成大",
    "dynasty": "song",
    "lines": [
      "梅子金黄杏子肥，麦花雪白菜花稀。",
      "日长篱落无人过，惟有蜻蜓蛱蝶飞。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "9d5e3f5ee21f",
    "title": "四时田园杂兴·其三十一",
    "author": "范成大",
    "dynasty": "song",
    "lines": [
      "昼出耘田夜绩麻，村庄儿女各当家。",
      "童孙未解供耕织，也傍桑阴学种瓜。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "4b21381d3a76",
    "title": "江上渔者",
    "author": "范仲淹",
    "dynasty": "song",
    "lines": [
      "江上往来人，但爱鲈鱼美。",
      "君看一叶舟，出没风波里。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "76a124fc2fb8",
    "title": "渔家傲·秋思",
    "author": "范仲淹",
    "dynasty": "song",
    "lines": [
      "塞下秋来风景异，衡阳雁去无留意。四面边声连角起，千嶂里，长烟落日孤城闭。",
      "浊酒一杯家万里，燕然未勒归无计。羌管悠悠霜满地，人不寐，将军白发征夫泪。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "315cf2d8892b",
    "title": "清平乐·春归何处",
    "author": "黄庭坚",
    "dynasty": "song",
    "lines": [
      "春归何处？寂寞无行路。若有人知春去处，唤取归来同住。",
      "春无踪迹谁知？除非问取黄鹂。百啭无人能解，因风飞过蔷薇。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "be04bba6288c",
    "title": "村晚",
    "author": "雷震",
    "dynasty": "song",
    "lines": [
      "草满池塘水满陂，山衔落日浸寒漪。",
      "牧童归去横牛背，短笛无腔信口吹。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "3e33bfbb8f79",
    "title": "如梦令·常记溪亭日暮",
    "author": "李清照",
    "dynasty": "song",
    "lines": [
      "常记溪亭日暮，沉醉不知归路。兴尽晚回舟，误入藕花深处。争渡，争渡，惊起一滩鸥鹭。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "e4cd80aceb52",
    "title": "夏日绝句",
    "author": "李清照",
    "dynasty": "song",
    "lines": [
      "生当作人杰，死亦为鬼雄。",
      "至今思项羽，不肯过江东。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "f547ff97e13f",
    "title": "渔家傲·记梦",
    "author": "李清照",
    "dynasty": "song",
    "lines": [
      "天接云涛连晓雾，星河欲转千帆舞。仿佛梦魂归帝所。闻天语，殷勤问我归何处。",
      "我报路长嗟日暮，学诗谩有惊人句。九万里风鹏正举。风休住，蓬舟吹取三山去！"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "63f2cb1073ff",
    "title": "题临安邸",
    "author": "林升",
    "dynasty": "song",
    "lines": [
      "山外青山楼外楼，西湖歌舞几时休？",
      "暖风熏得游人醉，直把杭州作汴州。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "8f1be8b774c2",
    "title": "雪梅",
    "author": "卢钺",
    "dynasty": "song",
    "lines": [
      "梅雪争春未肯降，骚人阁笔费评章。",
      "梅须逊雪三分白，雪却输梅一段香。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "2523dc7baa84",
    "title": "卜算子·咏梅",
    "author": "陆游",
    "dynasty": "song",
    "lines": [
      "驿外断桥边，寂寞开无主。已是黄昏独自愁，更着风和雨。(着同：著)",
      "无意苦争春，一任群芳妒。零落成泥碾作尘，只有香如故。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "dbabcfab1a1b",
    "title": "秋夜将晓出篱门迎凉有感二首·其二",
    "author": "陆游",
    "dynasty": "song",
    "lines": [
      "三万里河东入海，五千仞岳上摩天。",
      "遗民泪尽胡尘里，南望王师又一年。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "beab5faf1894",
    "title": "十一月四日风雨大作·其二",
    "author": "陆游",
    "dynasty": "song",
    "lines": [
      "僵卧孤村不自哀，尚思为国戍轮台。",
      "夜阑卧听风吹雨，铁马冰河入梦来。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "966c8a76211f",
    "title": "示儿",
    "author": "陆游",
    "dynasty": "song",
    "lines": [
      "死去元知万事空，但悲不见九州同。",
      "王师北定中原日，家祭无忘告乃翁。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "09294abb5f67",
    "title": "游山西村",
    "author": "陆游",
    "dynasty": "song",
    "lines": [
      "莫笑农家腊酒浑，丰年留客足鸡豚。",
      "山重水复疑无路，柳暗花明又一村。",
      "箫鼓追随春社近，衣冠简朴古风存。",
      "从今若许闲乘月，拄杖无时夜叩门。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "a3f6ef2ac6f7",
    "title": "采桑子·轻舟短棹西湖好",
    "author": "欧阳修",
    "dynasty": "song",
    "lines": [
      "轻舟短棹西湖好，绿水逶迤。芳草长堤，隐隐笙歌处处随。",
      "无风水面琉璃滑，不觉船移。微动涟漪，惊起沙禽掠岸飞。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "8005cc89b888",
    "title": "行香子·树绕村庄",
    "author": "秦观",
    "dynasty": "song",
    "lines": [
      "树绕村庄，水满陂塘。倚东风，豪兴徜徉。小园几许，收尽春光。有桃花红，李花白，菜花黄。",
      "远远围墙，隐隐茅堂。飏青旗，流水桥旁。偶然乘兴，步过东冈。正莺儿啼，燕儿舞，蝶儿忙。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "c1a07129a6d3",
    "title": "卜算子·黄州定慧院寓居作",
    "author": "苏轼",
    "dynasty": "song",
    "lines": [
      "缺月挂疏桐，漏断人初静。谁见幽人独往来，缥缈孤鸿影。",
      "惊起却回头，有恨无人省。拣尽寒枝不肯栖，寂寞沙洲冷。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "6b30455fdd3c",
    "title": "定风波·莫听穿林打叶声",
    "author": "苏轼",
    "dynasty": "song",
    "lines": [
      "三月七日，沙湖道中遇雨，雨具先去，同行皆狼狈，余独不觉。已而遂晴，故作此(词)。",
      "莫听穿林打叶声，何妨吟啸且徐行。竹杖芒鞋轻胜马，谁怕？一蓑烟雨任平生。",
      "料峭春风吹酒醒，微冷，山头斜照却相迎。回首向来萧瑟处，归去，也无风雨也无晴。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "a9a16104dd1b",
    "title": "浣溪沙·游蕲水清泉寺",
    "author": "苏轼",
    "dynasty": "song",
    "lines": [
      "游蕲水清泉寺，寺临兰溪，溪水西流。",
      "山下兰芽短浸溪，松间沙路净无泥，萧萧暮雨子规啼。",
      "谁道人生无再少？门前流水尚能西！休将白发唱黄鸡。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "cd140bf494da",
    "title": "惠崇春江晚景",
    "author": "苏轼",
    "dynasty": "song",
    "lines": [
      "竹外桃花三两枝，春江水暖鸭先知。",
      "蒌蒿满地芦芽短，正是河豚欲上时。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "85b8792a66ac",
    "title": "江城子·密州出猎",
    "author": "苏轼",
    "dynasty": "song",
    "lines": [
      "老夫聊发少年狂，左牵黄，右擎苍，锦帽貂裘，千骑卷平冈。为报倾城随太守，亲射虎，看孙郎。",
      "酒酣胸胆尚开张。鬓微霜，又何妨！持节云中，何日遣冯唐？会挽雕弓如满月，西北望，射天狼。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "0eda7b78250a",
    "title": "六月二十七日望湖楼醉书",
    "author": "苏轼",
    "dynasty": "song",
    "lines": [
      "黑云翻墨未遮山，白雨跳珠乱入船。",
      "卷地风来忽吹散，望湖楼下水如天。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "632c5beb84eb",
    "title": "水调歌头·明月几时有",
    "author": "苏轼",
    "dynasty": "song",
    "lines": [
      "丙辰中秋，欢饮达旦，大醉，作此篇，兼怀子由。",
      "明月几时有？把酒问青天。不知天上宫阙，今夕是何年。我欲乘风归去，又恐琼楼玉宇，高处不胜寒。起舞弄清影，何似在人间。",
      "转朱阁，低绮户，照无眠。不应有恨，何事长向别时圆？人有悲欢离合，月有阴晴圆缺，此事古难全。但愿人长久，千里共婵娟。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "f2f5469a6044",
    "title": "题西林壁",
    "author": "苏轼",
    "dynasty": "song",
    "lines": [
      "横看成岭侧成峰，远近高低各不同。",
      "不识庐山真面目，只缘身在此山中。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "8949464433f0",
    "title": "饮湖上初晴后雨",
    "author": "苏轼",
    "dynasty": "song",
    "lines": [
      "水光潋滟晴方好，山色空蒙雨亦奇。",
      "欲把西湖比西子，淡妆浓抹总相宜。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "4a272f472fee",
    "title": "登飞来峰",
    "author": "王安石",
    "dynasty": "song",
    "lines": [
      "飞来山上千寻塔，闻说鸡鸣见日升。",
      "不畏浮云遮望眼，自缘身在最高层。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "846e626d74d3",
    "title": "梅花",
    "author": "王安石",
    "dynasty": "song",
    "lines": [
      "墙角数枝梅，凌寒独自开。",
      "遥知不是雪，为有暗香来。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "df14e6fd217b",
    "title": "泊船瓜洲",
    "author": "王安石",
    "dynasty": "song",
    "lines": [
      "京口瓜洲一水间，钟山只隔数重山。",
      "春风又绿江南岸，明月何时照我还。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "3d787de04152",
    "title": "书湖阴先生壁",
    "author": "王安石",
    "dynasty": "song",
    "lines": [
      "茅檐长扫净无苔，花木成畦手自栽。",
      "一水护田将绿绕，两山排闼送青来。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "a167901c9c90",
    "title": "元日",
    "author": "王安石",
    "dynasty": "song",
    "lines": [
      "爆竹声中一岁除，春风送暖入屠苏。",
      "千门万户曈曈日，总把新桃换旧符。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "ee1bd6238d4a",
    "title": "卜算子·送鲍浩然之浙东",
    "author": "王观",
    "dynasty": "song",
    "lines": [
      "水是眼波横，山是眉峰聚。欲问行人去那边？眉眼盈盈处。",
      "才始送春归，又送君归去。若到江南赶上春，千万和春住。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "5796865dca4a",
    "title": "过零丁洋",
    "author": "文天祥",
    "dynasty": "song",
    "lines": [
      "辛苦遭逢起一经，干戈寥落四周星。",
      "山河破碎风飘絮，身世浮沉雨打萍。",
      "惶恐滩头说惶恐，零丁洋里叹零丁。",
      "人生自古谁无死？留取丹心照汗青。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "04c121ce6a85",
    "title": "南安军",
    "author": "文天祥",
    "dynasty": "song",
    "lines": [
      "梅花南北路，风雨湿征衣。",
      "出岭同谁出？归乡如此归！",
      "山河千古在，城郭一时非。",
      "饿死真吾志，梦中行采薇。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "07f5e3403665",
    "title": "乡村四月",
    "author": "翁卷",
    "dynasty": "song",
    "lines": [
      "绿遍山原白满川，子规声里雨如烟。",
      "乡村四月闲人少，才了蚕桑又插田。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "2ee36eb2ccf7",
    "title": "丑奴儿·书博山道中壁",
    "author": "辛弃疾",
    "dynasty": "song",
    "lines": [
      "少年不识愁滋味，爱上层楼。爱上层楼，为赋新词强说愁。",
      "而今识尽愁滋味，欲说还休。欲说还休，却道“天凉好个秋”！"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "3cfc9856b57a",
    "title": "南乡子·登京口北固亭有怀",
    "author": "辛弃疾",
    "dynasty": "song",
    "lines": [
      "何处望神州？满眼风光北固楼。千古兴亡多少事？悠悠。不尽长江滚滚流。",
      "年少万兜鍪，坐断东南战未休。天下英雄谁敌手？曹刘。生子当如孙仲谋。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "9822debcdc64",
    "title": "破阵子·为陈同甫赋壮词以寄之",
    "author": "辛弃疾",
    "dynasty": "song",
    "lines": [
      "醉里挑灯看剑，梦回吹角连营。八百里分麾下炙，五十弦翻塞外声，沙场秋点兵。",
      "马作的卢飞快，弓如霹雳弦惊。了却君王天下事，赢得生前身后名。可怜白发生！"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "03e80e28a0c2",
    "title": "清平乐·村居",
    "author": "辛弃疾",
    "dynasty": "song",
    "lines": [
      "茅檐低小，溪上青青草。醉里吴音相媚好，白发谁家翁媪？",
      "大儿锄豆溪东，中儿正织鸡笼。最喜小儿亡赖，溪头卧剥莲蓬。(亡同：无)"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "9d2a73f5e3bd",
    "title": "太常引·建康中秋夜为吕叔潜赋",
    "author": "辛弃疾",
    "dynasty": "song",
    "lines": [
      "一轮秋影转金波，飞镜又重磨。把酒问姮娥：被白发，欺人奈何？",
      "乘风好去，长空万里，直下看山河。斫去桂婆娑，人道是，清光更多。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "f090d65212f4",
    "title": "西江月·夜行黄沙道中",
    "author": "辛弃疾",
    "dynasty": "song",
    "lines": [
      "明月别枝惊鹊，清风半夜鸣蝉。稻花香里说丰年，听取蛙声一片。",
      "七八个星天外，两三点雨山前。旧时茅店社林边，路转溪桥忽见。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "eda29e11ff49",
    "title": "浣溪沙·一曲新词酒一杯",
    "author": "晏殊",
    "dynasty": "song",
    "lines": [
      "一曲新词酒一杯，去年天气旧亭台。夕阳西下几时回？",
      "无可奈何花落去，似曾相识燕归来。小园香径独徘徊。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "9b06cd24ed3a",
    "title": "过松源晨炊漆公店",
    "author": "杨万里",
    "dynasty": "song",
    "lines": [
      "莫言下岭便无难，赚得行人错喜欢。",
      "政入万山围子里，一山放出一山拦。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "f92fb36ff846",
    "title": "宿新市徐公店",
    "author": "杨万里",
    "dynasty": "song",
    "lines": [
      "篱落疏疏一径深，树头新绿未成阴。",
      "儿童急走追黄蝶，飞入菜花无处寻。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "31dd7d07323c",
    "title": "小池",
    "author": "杨万里",
    "dynasty": "song",
    "lines": [
      "泉眼无声惜细流，树阴照水爱晴柔。",
      "小荷才露尖尖角，早有蜻蜓立上头。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "3ab4125fd0f1",
    "title": "晓出净慈寺送林子方",
    "author": "杨万里",
    "dynasty": "song",
    "lines": [
      "毕竟西湖六月中，风光不与四时同。",
      "接天莲叶无穷碧，映日荷花别样红。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "4bb194abd528",
    "title": "稚子弄冰",
    "author": "杨万里",
    "dynasty": "song",
    "lines": [
      "稚子金盆脱晓冰，彩丝穿取当银钲。",
      "敲成玉磬穿林响，忽作玻璃碎地声。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "7ccd1778ba07",
    "title": "夜书所见",
    "author": "叶绍翁",
    "dynasty": "song",
    "lines": [
      "萧萧梧叶送寒声，江上秋风动客情。",
      "知有儿童挑促织，夜深篱落一灯明。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "a31b957aba53",
    "title": "游园不值",
    "author": "叶绍翁",
    "dynasty": "song",
    "lines": [
      "应怜屐齿印苍苔，小扣柴扉久不开。",
      "春色满园关不住，一枝红杏出墙来。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "c1537124e930",
    "title": "约客",
    "author": "赵师秀",
    "dynasty": "song",
    "lines": [
      "黄梅时节家家雨，青草池塘处处蛙。",
      "有约不来过夜半，闲敲棋子落灯花。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "a3d4996007f0",
    "title": "相见欢·金陵城上西楼",
    "author": "朱敦儒",
    "dynasty": "song",
    "lines": [
      "金陵城上西楼，倚清秋。万里夕阳垂地大江流。",
      "中原乱，簪缨散，几时收？试倩悲风吹泪过扬州。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "ba4626c44270",
    "title": "春日",
    "author": "朱熹",
    "dynasty": "song",
    "lines": [
      "胜日寻芳泗水滨，无边光景一时新。",
      "等闲识得东风面，万紫千红总是春。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "dd1c97accf6e",
    "title": "观书有感·其二",
    "author": "朱熹",
    "dynasty": "song",
    "lines": [
      "昨夜江边春水生，蒙冲巨舰一毛轻。",
      "向来枉费推移力，此日中流自在行。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "4c1364cb1da5",
    "title": "观书有感·其一",
    "author": "朱熹",
    "dynasty": "song",
    "lines": [
      "半亩方塘一鉴开，天光云影共徘徊。",
      "问渠那得清如许？为有源头活水来。(那通：哪)"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "f996111bff75",
    "title": "敕勒歌",
    "author": "乐府诗集",
    "dynasty": "southern-northern",
    "lines": [
      "敕勒川，阴山下。",
      "天似穹庐，笼盖四野。",
      "天苍苍，野茫茫，风吹草低见牛羊。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "2d6b0c83a500",
    "title": "木兰诗",
    "author": "乐府诗集",
    "dynasty": "southern-northern",
    "lines": [
      "唧唧复唧唧，木兰当户织。不闻机杼声，唯闻女叹息。",
      "问女何所思，问女何所忆。女亦无所思，女亦无所忆。昨夜见军帖，可汗大点兵，军书十二卷，卷卷有爷名。阿爷无大儿，木兰无长兄，愿为市鞍马，从此替爷征。",
      "东市买骏马，西市买鞍鞯，南市买辔头，北市买长鞭。旦辞爷娘去，暮宿黄河边，不闻爷娘唤女声，但闻黄河流水鸣溅溅。旦辞黄河去，暮至黑山头，不闻爷娘唤女声，但闻燕山胡骑鸣啾啾。",
      "万里赴戎机，关山度若飞。朔气传金柝，寒光照铁衣。将军百战死，壮士十年归。",
      "归来见天子，天子坐明堂。策勋十二转，赏赐百千强。可汗问所欲，木兰不用尚书郎，愿驰千里足，送儿还故乡。",
      "爷娘闻女来，出郭相扶将；阿姊闻妹来，当户理红妆；小弟闻姊来，磨刀霍霍向猪羊。开我东阁门，坐我西阁床。脱我战时袍，著我旧时裳。当窗理云鬓，对镜帖花黄。出门看火伴，火伴皆惊忙：同行十二年，不知木兰是女郎。",
      "雄兔脚扑朔，雌兔眼迷离；双兔傍地走，安能辨我是雄雌？"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "a8f44614071a",
    "title": "池上",
    "author": "白居易",
    "dynasty": "tang",
    "lines": [
      "小娃撑小艇，偷采白莲回。",
      "不解藏踪迹，浮萍一道开。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "5e26797704a7",
    "title": "大林寺桃花",
    "author": "白居易",
    "dynasty": "tang",
    "lines": [
      "人间四月芳菲尽，山寺桃花始盛开。",
      "长恨春归无觅处，不知转入此中来。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "ad8757771ddb",
    "title": "赋得古原草送别(节选)",
    "author": "白居易",
    "dynasty": "tang",
    "lines": [
      "离离原上草，一岁一枯荣。",
      "野火烧不尽，春风吹又生。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "2716dfb4d439",
    "title": "卖炭翁",
    "author": "白居易",
    "dynasty": "tang",
    "lines": [
      "卖炭翁，伐薪烧炭南山中。",
      "满面尘灰烟火色，两鬓苍苍十指黑。",
      "卖炭得钱何所营？身上衣裳口中食。",
      "可怜身上衣正单，心忧炭贱愿天寒。",
      "夜来城外一尺雪，晓驾炭车辗冰辙。",
      "牛困人饥日已高，市南门外泥中歇。",
      "翩翩两骑来是谁？黄衣使者白衫儿。",
      "手把文书口称敕，回车叱牛牵向北。",
      "一车炭，千余斤，宫使驱将惜不得。",
      "半匹红纱一丈绫，系向牛头充炭直。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "0daa9748bcb5",
    "title": "暮江吟",
    "author": "白居易",
    "dynasty": "tang",
    "lines": [
      "一道残阳铺水中，半江瑟瑟半江红。",
      "可怜九月初三夜，露似真珠月似弓。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "af218ed70405",
    "title": "钱塘湖春行",
    "author": "白居易",
    "dynasty": "tang",
    "lines": [
      "孤山寺北贾亭西，水面初平云脚低。",
      "几处早莺争暖树，谁家新燕啄春泥。",
      "乱花渐欲迷人眼，浅草才能没马蹄。",
      "最爱湖东行不足，绿杨阴里白沙堤。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "6ad0636b01a9",
    "title": "忆江南",
    "author": "白居易",
    "dynasty": "tang",
    "lines": [
      "江南好，风景旧曾谙。日出江花红胜火，春来江水绿如蓝。能不忆江南？"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "444df93c9bdf",
    "title": "白雪歌送武判官归京",
    "author": "岑参",
    "dynasty": "tang",
    "lines": [
      "北风卷地白草折，胡天八月即飞雪。",
      "忽如一夜春风来，千树万树梨花开。",
      "散入珠帘湿罗幕，狐裘不暖锦衾薄。",
      "将军角弓不得控，都护铁衣冷难着。",
      "瀚海阑干百丈冰，愁云惨淡万里凝。",
      "中军置酒饮归客，胡琴琵琶与羌笛。",
      "纷纷暮雪下辕门，风掣红旗冻不翻。",
      "轮台东门送君去，去时雪满天山路。",
      "山回路转不见君，雪上空留马行处。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "10d21c96ba71",
    "title": "逢入京使",
    "author": "岑参",
    "dynasty": "tang",
    "lines": [
      "故园东望路漫漫，双袖龙钟泪不干。",
      "马上相逢无纸笔，凭君传语报平安。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "1a98a1d6bae1",
    "title": "行军九日思长安故园",
    "author": "岑参",
    "dynasty": "tang",
    "lines": [
      "强欲登高去，无人送酒来。",
      "遥怜故园菊，应傍战场开。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "e2890c61279c",
    "title": "题破山寺后禅院",
    "author": "常建",
    "dynasty": "tang",
    "lines": [
      "清晨入古寺，初日照高林。",
      "竹径通幽处，禅房花木深。",
      "山光悦鸟性，潭影空人心。",
      "万籁此都寂，但余钟磬音。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "4083a01ac833",
    "title": "登幽州台歌",
    "author": "陈子昂",
    "dynasty": "tang",
    "lines": [
      "前不见古人，后不见来者。",
      "念天地之悠悠，独怆然而涕下！"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "b0d3f72465ef",
    "title": "黄鹤楼",
    "author": "崔颢",
    "dynasty": "tang",
    "lines": [
      "昔人已乘黄鹤去，此地空余黄鹤楼。",
      "黄鹤一去不复返，白云千载空悠悠。",
      "晴川历历汉阳树，芳草萋萋鹦鹉洲。",
      "日暮乡关何处是？烟波江上使人愁。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "89d3a63c6d7f",
    "title": "春望",
    "author": "杜甫",
    "dynasty": "tang",
    "lines": [
      "国破山河在，城春草木深。",
      "感时花溅泪，恨别鸟惊心。",
      "烽火连三月，家书抵万金。",
      "白头搔更短，浑欲不胜簪。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "d48451f00541",
    "title": "春夜喜雨",
    "author": "杜甫",
    "dynasty": "tang",
    "lines": [
      "好雨知时节，当春乃发生。",
      "随风潜入夜，润物细无声。",
      "野径云俱黑，江船火独明。",
      "晓看红湿处，花重锦官城。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "514b8bc0ee4f",
    "title": "江南逢李龟年",
    "author": "杜甫",
    "dynasty": "tang",
    "lines": [
      "岐王宅里寻常见，崔九堂前几度闻。",
      "正是江南好风景，落花时节又逢君。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "85e46c4b3dbc",
    "title": "江畔独步寻花·其五",
    "author": "杜甫",
    "dynasty": "tang",
    "lines": [
      "黄师塔前江水东，春光懒困倚微风。",
      "桃花一簇开无主，可爱深红爱浅红？"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "549473b5211c",
    "title": "绝句",
    "author": "杜甫",
    "dynasty": "tang",
    "lines": [
      "两个黄鹂鸣翠柳，一行白鹭上青天。",
      "窗含西岭千秋雪，门泊东吴万里船。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "e5e7911da1d2",
    "title": "绝句",
    "author": "杜甫",
    "dynasty": "tang",
    "lines": [
      "迟日江山丽，春风花草香。",
      "泥融飞燕子，沙暖睡鸳鸯。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "8e9ecc95d6a4",
    "title": "茅屋为秋风所破歌",
    "author": "杜甫",
    "dynasty": "tang",
    "lines": [
      "八月秋高风怒号，卷我屋上三重茅。茅飞渡江洒江郊，高者挂罥长林梢，下者飘转沉塘坳。",
      "南村群童欺我老无力，忍能对面为盗贼。公然抱茅入竹去，唇焦口燥呼不得，归来倚杖自叹息。",
      "俄顷风定云墨色，秋天漠漠向昏黑。布衾多年冷似铁，娇儿恶卧踏里裂。床头屋漏无干处，雨脚如麻未断绝。自经丧乱少睡眠，长夜沾湿何由彻！",
      "安得广厦千万间，大庇天下寒士俱欢颜！风雨不动安如山。呜呼！何时眼前突兀见此屋，吾庐独破受冻死亦足！"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "93ac46de573f",
    "title": "石壕吏",
    "author": "杜甫",
    "dynasty": "tang",
    "lines": [
      "暮投石壕村，有吏夜捉人。",
      "老翁逾墙走，老妇出门看。",
      "吏呼一何怒！妇啼一何苦！",
      "听妇前致词：三男邺城戍。",
      "一男附书至，二男新战死。",
      "存者且偷生，死者长已矣！",
      "室中更无人，惟有乳下孙。",
      "有孙母未去，出入无完裙。",
      "老妪力虽衰，请从吏夜归。",
      "急应河阳役，犹得备晨炊。",
      "夜久语声绝，如闻泣幽咽。",
      "天明登前途，独与老翁别。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "efec283b31e0",
    "title": "望岳",
    "author": "杜甫",
    "dynasty": "tang",
    "lines": [
      "岱宗夫如何？齐鲁青未了。",
      "造化钟神秀，阴阳割昏晓。",
      "荡胸生曾云，决眦入归鸟。(曾同：层)",
      "会当凌绝顶，一览众山小。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "519029b7355c",
    "title": "闻官军收河南河北",
    "author": "杜甫",
    "dynasty": "tang",
    "lines": [
      "剑外忽传收蓟北，初闻涕泪满衣裳。",
      "却看妻子愁何在，漫卷诗书喜欲狂。",
      "白日放歌须纵酒，青春作伴好还乡。",
      "即从巴峡穿巫峡，便下襄阳向洛阳。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "ad6f7cfa10c2",
    "title": "月夜忆舍弟",
    "author": "杜甫",
    "dynasty": "tang",
    "lines": [
      "戍鼓断人行，边秋一雁声。",
      "露从今夜白，月是故乡明。",
      "有弟皆分散，无家问死生。",
      "寄书长不达，况乃未休兵。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "3fb397218a1e",
    "title": "赤壁",
    "author": "杜牧",
    "dynasty": "tang",
    "lines": [
      "折戟沉沙铁未销，自将磨洗认前朝。",
      "东风不与周郎便，铜雀春深锁二乔。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "33cbdb2cf9b3",
    "title": "江南春",
    "author": "杜牧",
    "dynasty": "tang",
    "lines": [
      "千里莺啼绿映红，水村山郭酒旗风。",
      "南朝四百八十寺，多少楼台烟雨中。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "8e8011f614fb",
    "title": "泊秦淮",
    "author": "杜牧",
    "dynasty": "tang",
    "lines": [
      "烟笼寒水月笼沙，夜泊秦淮近酒家。",
      "商女不知亡国恨，隔江犹唱后庭花。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "d3e3283daac5",
    "title": "清明",
    "author": "杜牧",
    "dynasty": "tang",
    "lines": [
      "清明时节雨纷纷，路上行人欲断魂。",
      "借问酒家何处有？牧童遥指杏花村。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "3c36881bd247",
    "title": "山行",
    "author": "杜牧",
    "dynasty": "tang",
    "lines": [
      "远上寒山石径斜，白云生处有人家。",
      "停车坐爱枫林晚，霜叶红于二月花。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "4b3ccba01be6",
    "title": "别董大",
    "author": "高适",
    "dynasty": "tang",
    "lines": [
      "千里黄云白日曛，北风吹雁雪纷纷。",
      "莫愁前路无知己，天下谁人不识君。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "f26e62f4bfc8",
    "title": "寒食",
    "author": "韩翃",
    "dynasty": "tang",
    "lines": [
      "春城无处不飞花，寒食东风御柳斜。",
      "日暮汉宫传蜡烛，轻烟散入五侯家。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "9aadcdc29984",
    "title": "晚春二首·其一",
    "author": "韩愈",
    "dynasty": "tang",
    "lines": [
      "草树知春不久归，百般红紫斗芳菲。",
      "杨花榆荚无才思，惟解漫天作雪飞。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "7e09f12b287c",
    "title": "早春呈水部张十八员外",
    "author": "韩愈",
    "dynasty": "tang",
    "lines": [
      "天街小雨润如酥，草色遥看近却无。",
      "最是一年春好处，绝胜烟柳满皇都。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "076cedfce20c",
    "title": "左迁至蓝关示侄孙湘",
    "author": "韩愈",
    "dynasty": "tang",
    "lines": [
      "一封朝奏九重天，夕贬潮州路八千。",
      "欲为圣明除弊事，肯将衰朽惜残年！",
      "云横秦岭家何在？雪拥蓝关马不前。",
      "知汝远来应有意，好收吾骨瘴江边。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "f459f8ed8d23",
    "title": "回乡偶书",
    "author": "贺知章",
    "dynasty": "tang",
    "lines": [
      "少小离家老大回，乡音无改鬓毛衰。",
      "儿童相见不相识，笑问客从何处来。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "9936770100ef",
    "title": "咏柳",
    "author": "贺知章",
    "dynasty": "tang",
    "lines": [
      "碧玉妆成一树高，万条垂下绿丝绦。",
      "不知细叶谁裁出，二月春风似剪刀。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "200d28227643",
    "title": "小儿垂钓",
    "author": "胡令能",
    "dynasty": "tang",
    "lines": [
      "蓬头稚子学垂纶，侧坐莓苔草映身。",
      "路人借问遥招手，怕得鱼惊不应人。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "40954072f541",
    "title": "寻隐者不遇",
    "author": "贾岛",
    "dynasty": "tang",
    "lines": [
      "松下问童子，言师采药去。",
      "只在此山中，云深不知处。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "be1894114330",
    "title": "春夜洛城闻笛",
    "author": "李白",
    "dynasty": "tang",
    "lines": [
      "谁家玉笛暗飞声，散入春风满洛城。",
      "此夜曲中闻折柳，何人不起故园情。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "1da5349ad9e4",
    "title": "独坐敬亭山",
    "author": "李白",
    "dynasty": "tang",
    "lines": [
      "众鸟高飞尽，孤云独去闲。",
      "相看两不厌，只有敬亭山。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "d50eb19399e6",
    "title": "渡荆门送别",
    "author": "李白",
    "dynasty": "tang",
    "lines": [
      "渡远荆门外，来从楚国游。",
      "山随平野尽，江入大荒流。",
      "月下飞天镜，云生结海楼。",
      "仍怜故乡水，万里送行舟。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "f13ab2fe8afd",
    "title": "峨眉山月歌",
    "author": "李白",
    "dynasty": "tang",
    "lines": [
      "峨眉山月半轮秋，影入平羌江水流。",
      "夜发清溪向三峡，思君不见下渝州。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "8616581bb564",
    "title": "古朗月行(节选)",
    "author": "李白",
    "dynasty": "tang",
    "lines": [
      "小时不识月，呼作白玉盘。",
      "又疑瑶台镜，飞在青云端。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "d3f231047aef",
    "title": "黄鹤楼送孟浩然之广陵",
    "author": "李白",
    "dynasty": "tang",
    "lines": [
      "故人西辞黄鹤楼，烟花三月下扬州。",
      "孤帆远影碧空尽，唯见长江天际流。(唯通：惟)"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "c35a60c1a8e2",
    "title": "静夜思",
    "author": "李白",
    "dynasty": "tang",
    "lines": [
      "床前明月光，疑是地上霜。",
      "举头望明月，低头思故乡。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "c348339f28fd",
    "title": "送友人",
    "author": "李白",
    "dynasty": "tang",
    "lines": [
      "青山横北郭，白水绕东城。",
      "此地一为别，孤蓬万里征。",
      "浮云游子意，落日故人情。",
      "挥手自兹去，萧萧班马鸣。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "62802abab937",
    "title": "望庐山瀑布",
    "author": "李白",
    "dynasty": "tang",
    "lines": [
      "日照香炉生紫烟，遥看瀑布挂前川。",
      "飞流直下三千尺，疑是银河落九天。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "97e6296bfb8d",
    "title": "望天门山",
    "author": "李白",
    "dynasty": "tang",
    "lines": [
      "天门中断楚江开，碧水东流至此回。",
      "两岸青山相对出，孤帆一片日边来。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "62280919c9c5",
    "title": "闻王昌龄左迁龙标遥有此寄",
    "author": "李白",
    "dynasty": "tang",
    "lines": [
      "杨花落尽子规啼，闻道龙标过五溪。",
      "我寄愁心与明月，随君直到夜郎西。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "870828ca8aaa",
    "title": "行路难·其一",
    "author": "李白",
    "dynasty": "tang",
    "lines": [
      "金樽清酒斗十千，玉盘珍羞直万钱。(羞同：馐；直同：值)",
      "停杯投箸不能食，拔剑四顾心茫然。",
      "欲渡黄河冰塞川，将登太行雪满山。",
      "闲来垂钓碧溪上，忽复乘舟梦日边。",
      "行路难，行路难，多歧路，今安在？",
      "长风破浪会有时，直挂云帆济沧海。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "85f036fcc038",
    "title": "夜宿山寺",
    "author": "李白",
    "dynasty": "tang",
    "lines": [
      "危楼高百尺，手可摘星辰。",
      "不敢高声语，恐惊天上人。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "0f81015a040c",
    "title": "早发白帝城",
    "author": "李白",
    "dynasty": "tang",
    "lines": [
      "朝辞白帝彩云间，千里江陵一日还。",
      "两岸猿声啼不住，轻舟已过万重山。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "ca9eaf40a6ce",
    "title": "赠汪伦",
    "author": "李白",
    "dynasty": "tang",
    "lines": [
      "李白乘舟将欲行，忽闻岸上踏歌声。",
      "桃花潭水深千尺，不及汪伦送我情。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "55174e6ebe20",
    "title": "马诗二十三首·其五",
    "author": "李贺",
    "dynasty": "tang",
    "lines": [
      "大漠沙如雪，燕山月似钩。",
      "何当金络脑，快走踏清秋。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "a60e7fd3031b",
    "title": "雁门太守行",
    "author": "李贺",
    "dynasty": "tang",
    "lines": [
      "黑云压城城欲摧，甲光向日金鳞开。",
      "角声满天秋色里，塞上燕脂凝夜紫。",
      "半卷红旗临易水，霜重鼓寒声不起。",
      "报君黄金台上意，提携玉龙为君死。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "8bc9e1cc2b8f",
    "title": "风",
    "author": "李峤",
    "dynasty": "tang",
    "lines": [
      "解落三秋叶，能开二月花。",
      "过江千尺浪，入竹万竿斜。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "caef25db347c",
    "title": "嫦娥",
    "author": "李商隐",
    "dynasty": "tang",
    "lines": [
      "云母屏风烛影深，长河渐落晓星沉。",
      "嫦娥应悔偷灵药，碧海青天夜夜心。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "cd908d31f388",
    "title": "贾生",
    "author": "李商隐",
    "dynasty": "tang",
    "lines": [
      "宣室求贤访逐臣，贾生才调更无伦。",
      "可怜夜半虚前席，不问苍生问鬼神。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "1a4c484f9364",
    "title": "无题·相见时难别亦难",
    "author": "李商隐",
    "dynasty": "tang",
    "lines": [
      "相见时难别亦难，东风无力百花残。",
      "春蚕到死丝方尽，蜡炬成灰泪始干。",
      "晓镜但愁云鬓改，夜吟应觉月光寒。",
      "蓬山此去无多路，青鸟殷勤为探看。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "e46c43d13b97",
    "title": "夜雨寄北",
    "author": "李商隐",
    "dynasty": "tang",
    "lines": [
      "君问归期未有期，巴山夜雨涨秋池。",
      "何当共剪西窗烛，却话巴山夜雨时。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "6e878b858e01",
    "title": "悯农二首·其二",
    "author": "李绅",
    "dynasty": "tang",
    "lines": [
      "锄禾日当午，汗滴禾下土。",
      "谁知盘中餐，粒粒皆辛苦。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "4859914a4e16",
    "title": "悯农二首·其一",
    "author": "李绅",
    "dynasty": "tang",
    "lines": [
      "春种一粒粟，秋收万颗子。",
      "四海无闲田，农夫犹饿死。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "d89eb1125b6d",
    "title": "夜上受降城闻笛",
    "author": "李益",
    "dynasty": "tang",
    "lines": [
      "回乐烽前沙似雪，受降城外月如霜。",
      "不知何处吹芦管，一夜征人尽望乡。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "e152d043be94",
    "title": "乞巧",
    "author": "林杰",
    "dynasty": "tang",
    "lines": [
      "七夕今宵看碧霄，牵牛织女渡河桥。",
      "家家乞巧望秋月，穿尽红丝几万条。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "f6c40e3d4893",
    "title": "酬乐天扬州初逢席上见赠",
    "author": "刘禹锡",
    "dynasty": "tang",
    "lines": [
      "巴山楚水凄凉地，二十三年弃置身。",
      "怀旧空吟闻笛赋，到乡翻似烂柯人。",
      "沉舟侧畔千帆过，病树前头万木春。",
      "今日听君歌一曲，暂凭杯酒长精神。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "857567307e6a",
    "title": "浪淘沙·其一",
    "author": "刘禹锡",
    "dynasty": "tang",
    "lines": [
      "九曲黄河万里沙，浪淘风簸自天涯。",
      "如今直上银河去，同到牵牛织女家。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "4995f2f0581b",
    "title": "秋词·其一",
    "author": "刘禹锡",
    "dynasty": "tang",
    "lines": [
      "自古逢秋悲寂寥，我言秋日胜春朝。",
      "晴空一鹤排云上，便引诗情到碧霄。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "880912218fc8",
    "title": "望洞庭",
    "author": "刘禹锡",
    "dynasty": "tang",
    "lines": [
      "湖光秋月两相和，潭面无风镜未磨。",
      "遥望洞庭山水翠，白银盘里一青螺。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "a9a0b6b0eede",
    "title": "长沙过贾谊宅",
    "author": "刘长卿",
    "dynasty": "tang",
    "lines": [
      "三年谪宦此栖迟，万古惟留楚客悲。",
      "秋草独寻人去后，寒林空见日斜时。",
      "汉文有道恩犹薄，湘水无情吊岂知？",
      "寂寂江山摇落处，怜君何事到天涯！"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "58313be2d918",
    "title": "江雪",
    "author": "柳宗元",
    "dynasty": "tang",
    "lines": [
      "千山鸟飞绝，万径人踪灭。",
      "孤舟蓑笠翁，独钓寒江雪。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "9a9463173105",
    "title": "塞下曲",
    "author": "卢纶",
    "dynasty": "tang",
    "lines": [
      "月黑雁飞高，单于夜遁逃。",
      "欲将轻骑逐，大雪满弓刀。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "0cf974c0b70a",
    "title": "蜂",
    "author": "罗隐",
    "dynasty": "tang",
    "lines": [
      "不论平地与山尖，无限风光尽被占。",
      "采得百花成蜜后，为谁辛苦为谁甜？"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "eeb3869b6242",
    "title": "咏鹅",
    "author": "骆宾王",
    "dynasty": "tang",
    "lines": [
      "鹅，鹅，鹅，曲项向天歌。",
      "白毛浮绿水，红掌拨清波。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "ccee5691ba93",
    "title": "春晓",
    "author": "孟浩然",
    "dynasty": "tang",
    "lines": [
      "春眠不觉晓，处处闻啼鸟。",
      "夜来风雨声，花落知多少。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "4a0d548bebb3",
    "title": "过故人庄",
    "author": "孟浩然",
    "dynasty": "tang",
    "lines": [
      "故人具鸡黍，邀我至田家。",
      "绿树村边合，青山郭外斜。",
      "开轩面场圃，把酒话桑麻。",
      "待到重阳日，还来就菊花。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "63d3ff8f6b61",
    "title": "宿建德江",
    "author": "孟浩然",
    "dynasty": "tang",
    "lines": [
      "移舟泊烟渚，日暮客愁新。",
      "野旷天低树，江清月近人。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "ae20659aff8c",
    "title": "望洞庭湖上张丞相",
    "author": "孟浩然",
    "dynasty": "tang",
    "lines": [
      "八月湖水平，涵虚混太清。",
      "气蒸云梦泽，波撼岳阳城。",
      "欲济无舟楫，端居耻圣明。",
      "坐观垂钓者，徒有羡鱼情。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "161d06b0b556",
    "title": "游子吟",
    "author": "孟郊",
    "dynasty": "tang",
    "lines": [
      "慈母手中线，游子身上衣。",
      "临行密密缝，意恐迟迟归。",
      "谁言寸草心，报得三春晖。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "5775c79bcd34",
    "title": "送杜少府之任蜀州",
    "author": "王勃",
    "dynasty": "tang",
    "lines": [
      "城阙辅三秦，风烟望五津。",
      "与君离别意，同是宦游人。",
      "海内存知己，天涯若比邻。",
      "无为在歧路，儿女共沾巾。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "c953220f9f52",
    "title": "采莲曲",
    "author": "王昌龄",
    "dynasty": "tang",
    "lines": [
      "荷叶罗裙一色裁，芙蓉向脸两边开。",
      "乱入池中看不见，闻歌始觉有人来。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "b9e14c6e09aa",
    "title": "出塞",
    "author": "王昌龄",
    "dynasty": "tang",
    "lines": [
      "秦时明月汉时关，万里长征人未还。",
      "但使龙城飞将在，不教胡马度阴山。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "d1129db241ec",
    "title": "从军行七首·其四",
    "author": "王昌龄",
    "dynasty": "tang",
    "lines": [
      "青海长云暗雪山，孤城遥望玉门关。",
      "黄沙百战穿金甲，不破楼兰终不还。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "f433a64dd504",
    "title": "芙蓉楼送辛渐",
    "author": "王昌龄",
    "dynasty": "tang",
    "lines": [
      "寒雨连江夜入吴，平明送客楚山孤。",
      "洛阳亲友如相问，一片冰心在玉壶。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "9312f5349cd7",
    "title": "凉州词",
    "author": "王翰",
    "dynasty": "tang",
    "lines": [
      "葡萄美酒夜光杯，欲饮琵琶马上催。",
      "醉卧沙场君莫笑，古来征战几人回？"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "13c4e7658327",
    "title": "野望",
    "author": "王绩",
    "dynasty": "tang",
    "lines": [
      "东皋薄暮望，徙倚欲何依。",
      "树树皆秋色，山山唯落晖。",
      "牧人驱犊返，猎马带禽归。",
      "相顾无相识，长歌怀采薇。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "2367f5ae6dee",
    "title": "十五夜望月",
    "author": "王建",
    "dynasty": "tang",
    "lines": [
      "中庭地白树栖鸦，冷露无声湿桂花。",
      "今夜月明人尽望，不知秋思落谁家。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "720b46d38537",
    "title": "次北固山下",
    "author": "王湾",
    "dynasty": "tang",
    "lines": [
      "客路青山外，行舟绿水前。",
      "潮平两岸阔，风正一帆悬。",
      "海日生残夜，江春入旧年。",
      "乡书何处达，归雁洛阳边。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "b6bd9a33dfd7",
    "title": "画",
    "author": "王维",
    "dynasty": "tang",
    "lines": [
      "远看山有色，近听水无声。",
      "春去花还在，人来鸟不惊。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "d75a706935de",
    "title": "九月九日忆山东兄弟",
    "author": "王维",
    "dynasty": "tang",
    "lines": [
      "独在异乡为异客，每逢佳节倍思亲。",
      "遥知兄弟登高处，遍插茱萸少一人。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "e9b1a8b4def0",
    "title": "鹿柴",
    "author": "王维",
    "dynasty": "tang",
    "lines": [
      "空山不见人，但闻人语响。",
      "返景入深林，复照青苔上。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "8ec950bd1395",
    "title": "鸟鸣涧",
    "author": "王维",
    "dynasty": "tang",
    "lines": [
      "人闲桂花落，夜静春山空。",
      "月出惊山鸟，时鸣春涧中。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "44ba4afb80db",
    "title": "山居秋暝",
    "author": "王维",
    "dynasty": "tang",
    "lines": [
      "空山新雨后，天气晚来秋。",
      "明月松间照，清泉石上流。",
      "竹喧归浣女，莲动下渔舟。",
      "随意春芳歇，王孙自可留。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "eae647c5c110",
    "title": "使至塞上",
    "author": "王维",
    "dynasty": "tang",
    "lines": [
      "单车欲问边，属国过居延。",
      "征蓬出汉塞，归雁入胡天。",
      "大漠孤烟直，长河落日圆。",
      "萧关逢候骑，都护在燕然。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "12a2295aa76b",
    "title": "送元二使安西",
    "author": "王维",
    "dynasty": "tang",
    "lines": [
      "渭城朝雨浥轻尘，客舍青青柳色新。",
      "劝君更尽一杯酒，西出阳关无故人。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "4809b5e7a16a",
    "title": "竹里馆",
    "author": "王维",
    "dynasty": "tang",
    "lines": [
      "独坐幽篁里，弹琴复长啸。",
      "深林人不知，明月来相照。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "c90ff9ea5a71",
    "title": "登鹳雀楼",
    "author": "王之涣",
    "dynasty": "tang",
    "lines": [
      "白日依山尽，黄河入海流。",
      "欲穷千里目，更上一层楼。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "3963afd966bc",
    "title": "凉州词二首·其一",
    "author": "王之涣",
    "dynasty": "tang",
    "lines": [
      "黄河远上白云间，一片孤城万仞山。",
      "羌笛何须怨杨柳，春风不度玉门关。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "f6bd6356c843",
    "title": "滁州西涧",
    "author": "韦应物",
    "dynasty": "tang",
    "lines": [
      "独怜幽草涧边生，上有黄鹂深树鸣。",
      "春潮带雨晚来急，野渡无人舟自横。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "8d18260838e2",
    "title": "商山早行",
    "author": "温庭筠",
    "dynasty": "tang",
    "lines": [
      "晨起动征铎，客行悲故乡。",
      "鸡声茅店月，人迹板桥霜。",
      "槲叶落山路，枳花明驿墙。",
      "因思杜陵梦，凫雁满回塘。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "65bc4719e0b1",
    "title": "咸阳城东楼",
    "author": "许浑",
    "dynasty": "tang",
    "lines": [
      "一上高城万里愁，蒹葭杨柳似汀洲。",
      "溪云初起日沉阁，山雨欲来风满楼。",
      "鸟下绿芜秦苑夕，蝉鸣黄叶汉宫秋。",
      "行人莫问当年事，故国东来渭水流。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "c8414cce04e1",
    "title": "蝉",
    "author": "虞世南",
    "dynasty": "tang",
    "lines": [
      "垂緌饮清露，流响出疏桐。",
      "居高声自远，非是藉秋风。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "6fb73f607ad3",
    "title": "枫桥夜泊",
    "author": "张继",
    "dynasty": "tang",
    "lines": [
      "月落乌啼霜满天，江枫渔火对愁眠。",
      "姑苏城外寒山寺，夜半钟声到客船。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "ee72baa043c8",
    "title": "渔歌子·西塞山前白鹭飞",
    "author": "张志和",
    "dynasty": "tang",
    "lines": [
      "西塞山前白鹭飞，桃花流水鳜鱼肥。",
      "青箬笠，绿蓑衣，斜风细雨不须归。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "7ddbcf2c2131",
    "title": "梁甫行",
    "author": "曹植",
    "dynasty": "wei-jin",
    "lines": [
      "八方各异气，千里殊风雨。",
      "剧哉边海民，寄身于草野。",
      "妻子象禽兽，行止依林阻。",
      "柴门何萧条，狐兔翔我宇。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "5b90a9bb5230",
    "title": "饮酒·其五",
    "author": "陶渊明",
    "dynasty": "wei-jin",
    "lines": [
      "结庐在人境，而无车马喧。",
      "问君何能尔？心远地自偏。",
      "采菊东篱下，悠然见南山。",
      "山气日夕佳，飞鸟相与还。",
      "此中有真意，欲辨已忘言。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "9dcf133d25cc",
    "title": "天净沙·秋思",
    "author": "马致远",
    "dynasty": "yuan",
    "lines": [
      "枯藤老树昏鸦，小桥流水人家，古道西风瘦马。夕阳西下，断肠人在天涯。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "82fd6027caf3",
    "title": "墨梅",
    "author": "王冕",
    "dynasty": "yuan",
    "lines": [
      "我家洗砚池头树，朵朵花开淡墨痕。",
      "不要人夸好颜色，只留清气满乾坤。"
    ],
    "curriculumLevels": [
      "primary"
    ]
  },
  {
    "sourceId": "614c91077b60",
    "title": "山坡羊·骊山怀古",
    "author": "张养浩",
    "dynasty": "yuan",
    "lines": [
      "骊山四顾，阿房一炬，当时奢侈今何处？只见草萧疏，水萦纡。",
      "至今遗恨迷烟树。列国周齐秦汉楚。赢，都变做了土；输，都变做了土。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  },
  {
    "sourceId": "1bd53945715b",
    "title": "山坡羊·潼关怀古",
    "author": "张养浩",
    "dynasty": "yuan",
    "lines": [
      "峰峦如聚，波涛如怒，山河表里潼关路。望西都，意踌躇。",
      "伤心秦汉经行处，宫阙万间都做了土。兴，百姓苦；亡，百姓苦。"
    ],
    "curriculumLevels": [
      "middle"
    ]
  }
]
